import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative w-full overflow-hidden" style={{
    background: 'linear-gradient(180deg, #C5DDD1 0%, #F0F7F4 50%, #FAFAF7 100%)'
  }} data-id="element-83">
      <div className="max-w-6xl mx-auto px-4 py-12 md:py-20" data-id="element-84">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12" data-id="element-85">
          <motion.div className="flex-1 text-center lg:text-left" initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-86">
            <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold leading-tight mb-6" style={{
            color: '#1A1A1A'
          }} data-id="element-87">
              Recupera tu abdomen y vuelve a cerrar tus pantalones favoritos en
              solo{' '}
              <span style={{
              color: '#C9A96E'
            }} data-id="element-88">
                72 horas
              </span>
            </h1>

            <h2 className="text-lg md:text-xl lg:text-2xl font-normal leading-relaxed mb-8" style={{
            color: '#4A4A4A'
          }} data-id="element-89">
              El protocolo de "Reseteo Digestivo" diseñado para mujeres de +30
              que están cansadas de sentirse inflamadas, pesadas y agotadas cada
              lunes por la mañana.
            </h2>

            <div className="flex justify-center lg:justify-start" data-id="element-90">
              <CTAButton text="¡SÍ, QUIERO DESINFLAMARME AHORA!" href="https://pay.hotmart.com/M104747962U" data-id="element-91" />
            </div>
          </motion.div>

          <motion.div className="flex-1 flex justify-center" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-92">
            <img src="https://cdn.magicpatterns.com/uploads/oGvffUNjs2TMMsCM4PyJLN/private_openrouter-generated-image-1772513941634.png" alt="Cero Inflamación en 72H - Ebook en tablet y celular" className="w-full max-w-md lg:max-w-lg drop-shadow-2xl" data-id="element-93" />
          </motion.div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-[#FAFAF7] to-transparent" data-id="element-94" />
    </section>;
}